import ReviewModel from "../../models/ReviewModel";
import { StarsReview } from "../utils/Stars/StarsReview";

export const Review: React.FC<{review: ReviewModel}> = (props) => {

    const date = new Date(props.review.date);

    const longMonth = date.toLocaleString('en-us', {month: 'long'});
    const day = date.getDate();
    const year = date.getFullYear();
    const dateRender = longMonth + ' ' + day + ', ' + year;

	return (    
        <div>
            <div className='col-sm-8 col-md-8'>
                <h5>{props.review.userEmail}</h5>
                <div className='row'>
                    <div className='col'>
                        {dateRender}
                    </div>

                    <div className='col'>
                        <StarsReview size={32} rating={props.review.rating}></StarsReview>
                    </div>

                    <div className='mt-2'>
                       <p>
                        {props.review.reviewDescription}
                       </p>
                    </div>
                    
                </div>
            </div>
            <hr></hr>
        </div>
        
    )
};
